var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -701,
    y: -149,
    width: 1280,
    height: 800,
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 8C0 3.58095 3.58095 0 8 0C12.4191 0 16 3.5819 16 8C16 12.4191 12.4191 16 8 16C3.58095 16 0 12.4191 0 8ZM10.9937 11.724L11.7064 11.0113C11.9021 10.8155 11.9021 10.4944 11.7064 10.2986L9.40777 8L11.724 5.71897C11.9197 5.52322 11.9197 5.20228 11.724 5.0063L11.0113 4.29362C10.8155 4.09787 10.4944 4.09787 10.2986 4.29362L8 6.59223L5.71897 4.27604C5.52322 4.08029 5.20228 4.08029 5.0063 4.27604L4.29362 4.98872C4.09787 5.18446 4.09787 5.50564 4.29362 5.70139L6.59223 8L4.27604 10.281C4.08029 10.4768 4.08029 10.7977 4.27604 10.9937L4.98872 11.7064C5.18446 11.9021 5.50564 11.9021 5.70139 11.7064L8 9.40777L10.281 11.724C10.4768 11.9197 10.7977 11.9197 10.9937 11.724Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.e93f9d502ea0c6e9d4f883af26840666.svg";
export { ForwardRef as ReactComponent };